import { inject, Injectable } from '@angular/core';

import { UserDetailDto, UserGetDTO, UserUpdateDto } from './users.model';

import { Observable } from 'rxjs';
import { BaseCrudService } from '../../services/apps/generic/base.service';
import { ApiResponseModel } from '../../core/api-response.model';
import { RoleService, RoleType } from '../../core/services/role.service';
import { environment } from '../../../environments/environment';

export interface AppUser {
  id: string;
  fullName: string;
  email: string;
  role: string;
}

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseCrudService<
  ApiResponseModel<UserGetDTO>,
  any,
  any,
  any
> {
  constructor() {
    super('/api/users');
  }
  roles = inject(RoleService);
  override get(
    id?: any,
    params?: Record<string, any>
  ): Observable<ApiResponseModel<UserGetDTO>> {
    const qp = {
      ...params,
      roleId: params?.['roleId'] ?? [
        this.roles.getRoleByName(RoleType.Admin)?.id,
        this.roles.getRoleByName(RoleType.Employee)?.id,
      ],
    };
    return super.get(id, qp);
  }

  getUserById(id: string) {
    return this.http.get<UserDetailDto>(
      `${environment.baseApiUrl}/api/users/${id}`
    );
  }
  updateUser(user: UserUpdateDto) {
    return this.http.put(`${environment.baseApiUrl}/api/users`, user);
  }
}
